import React, { useContext, useEffect, useMemo, useState } from 'react';
import { Img, svgSprite } from '../../../../../../../../../hybrid/wrappers';
// import FormTextArea from '../../../../../../../../../widgets/form/components/form-textarea/FormInputArea';
// import FormCheckbox from '../../../../../../widgets/form/components/form-checkbox/FormCheckbox/FormCheckbox';
import T from '../../../../../../../../../common/components/T';
// import { LangContext } from '../../../../../../../../../common/decorators/Language';
import UserContext from '../../../../../../../../../common/utils/getContext';
import FormSelect from '../../../../../../../../../widgets/form/components/form-dropdown/FormDropdown/FormDropdown';
import css from './Payment.module.scss';
// import classNames from 'classnames';
// import FormInput from '../../../../../../widgets/form/components/form-input/FormInput/FormInput';
// import { getTitle, validationPartSumNumbers } from './helpers';
import FinPasswordBlock from './financialPasswordBlock/FinPasswordBlock';
// import FormCheckboxSwitcher from '../../../../../../widgets/form/components/form-checkbox/FormCheckboxSwitcher/FormCheckboxSwitcher';
// import { linksInstructionsPayment } from '../../../../../adminpayment/initData';
// import ConvertBlock from './components/ConvertBlock/ConvertBlock';
import { PAYMENT_SYSTEM_TYPE } from './consts';
import { useSelectedPaymentSystem } from './hooks/useSelectedPaymentSystem';
import { usePayments } from './hooks/usePayments';
import { useConverting } from './hooks/useConverting';
import { generateUniqueId } from '../../../../../../../../../common/utils/utils';
import Display from '../../../../../../../../../common/components/Display';
// import { useSetSum } from './hooks/useSetSum';
// import SelectBlock from './components/SelectBlock/SelectBlock';
// import InternalAccBlock from './components/InternalAccBlock/InternalAccBlock';

const CartFooterForm = ({
    formDataError,
    setFormDataMain,
    storeData,
    selectedPaymentSystems,
    setSelectedPaymentSystems,
    setSelectedPayment,
    isComboPayment,
    // setIsComboPayment,
    // convertedData,
    setConvertedData,
    cartData,
    delivery
}) => {
    // const paymentSysContainerRef = useRef(null);

    // const { translation } = useContext(LangContext);
    const { localization, userToken, lang } = useContext(UserContext) || {};
    const [isActivePaymentSys, setIsActivePaymentSys] = useState(false);

    const [finPassError, setFinPassError] = useState('');
    const [selectedPayOption, setSelectedPayOption] = useState(null);

    const {
        selectedPaymentSys,
        currencyValue,
        handleSetSelectedPaymentSys,
        currentCurrenciesList,
        setCurrency,
        handleClickCheckboxInternalAcc,
        handleClickOnPaymentSys
        // handleClickCheckboxPaymentSys
    } = useSelectedPaymentSystem({
        isActivePaymentSys,
        isComboPayment,
        setSelectedPaymentSystems,
        setSelectedPayment,
        setIsActivePaymentSys,
        selectedPaymentSystems,
        cartData
    });

    const { isActiveInternalAcc } = usePayments({
        selectedPaymentSys,
        isComboPayment,
        selectedPaymentSystems,
        setSelectedPaymentSystems,
        cartData,
        setIsActivePaymentSys,
        localization,
        setConvertedData
    });

    const { convertLoading } = useConverting({
        userToken,
        lang,
        localization,
        cartData,
        selectedPaymentSystems,
        isComboPayment,
        setConvertedData
    });
    console.log(convertLoading);
    // const { handleSetPartOfSumValue } = useSetSum({ setSelectedPaymentSystems, cartData, selectedPaymentSys });

    // const formattedPaymentData = useMemo(() => {
    //     return storeData?.paymentData?.length
    //         ? storeData?.paymentData.map((item) => {
    //               return { ...item, value: item.id, label: item.title };
    //           })
    //         : [];
    // }, [storeData]);

    useEffect(() => {
        if (!selectedPaymentSystems?.length) {
            setIsActivePaymentSys(false);
        }
    }, [selectedPaymentSystems]);

    const paymentsErrors = useMemo(() => {
        let paymentsErrors = [];
        if (formDataError?.payments?.length) {
            paymentsErrors = [...paymentsErrors, ...formDataError?.payments];
        }
        if (formDataError.hasOwnProperty('payments.0') && formDataError['payments.0']?.length) {
            paymentsErrors = [...paymentsErrors, ...formDataError['payments.0']];
        }
        if (formDataError.hasOwnProperty('payments.1') && formDataError['payments.1']?.length) {
            paymentsErrors = [...paymentsErrors, ...formDataError['payments.1']];
        }
        Object.keys(formDataError || {}).forEach((key) => {
            if (key.includes('payments.0')) {
                paymentsErrors = [...paymentsErrors, ...formDataError[key]];
            }
        });
        return [...new Set(paymentsErrors)];
    }, [formDataError]);

    useEffect(() => {
        setFinPassError('');
    }, [selectedPaymentSystems]);
    useEffect(() => {
        setFinPassError(formDataError['finance_password'] || formDataError['financial_password']);
    }, [formDataError]);

    const payment_methods = useMemo(() => {
        const methods = [];
        storeData?.financeData?.forEach((fin_account) => {
            if (+fin_account?.balance < +cartData?.total_price) return;
            methods?.push({
                value: fin_account.id,
                label: (
                    <div className={css.finAccountWrapName}>
                        <div className={css.finAccountIcon}>
                            {svgSprite(
                                fin_account?.purpose === 'main'
                                    ? 'main-account-icon'
                                    : fin_account?.purpose === 'bonus'
                                    ? 'bonus-account-icon'
                                    : ''
                            )}
                        </div>
                        <p className={css.finAccountName}>
                            <span>{fin_account.name + ` (${fin_account?.accountCurrency?.code})`}</span>
                            <span className={css.finAccountBalance}>{fin_account.formatted_balance}</span>
                        </p>
                    </div>
                ),
                currency_account_id: fin_account?.id,
                account_id: fin_account?.finance_account_id,
                uniqueId: generateUniqueId()
            });
        });
        storeData?.paymentData?.forEach((pay_account) => {
            if (storeData['delivery_type'] === 'currier' && pay_account['alias'] === 'warehouse') {
                return;
            }
            methods?.push({
                value: pay_account.id,
                label: (
                    <p className={css.finAccountName}>
                        {pay_account?.image?.links?.preview ? (
                            <Img className={css.payAccountImage} src={pay_account?.image?.links?.preview} alt='Logo' />
                        ) : null}
                        <span>{pay_account.title}</span>
                        <span className={css.finAccountBalance}>{pay_account.balance_formatted}</span>
                    </p>
                ),
                ...pay_account,
                is_payment_system: true,
                uniqueId: generateUniqueId()
            });
        });
        return methods;
    }, [storeData?.['financeData'], storeData?.['paymentData'], storeData['delivery_type'], cartData]);

    const onSelectPaymentMethod = (key, val) => {
        setSelectedPayOption(val);
        if (val?.is_payment_system) {
            handleSetSelectedPaymentSys(PAYMENT_SYSTEM_TYPE, val);
        } else {
            handleClickCheckboxInternalAcc(val?.disabled, val, handleClickOnPaymentSys);
        }
    };
    useEffect(() => {
        if (['paymentstripe']?.includes(selectedPayOption?.alias)) {
            setIsActivePaymentSys(true);
        } else {
            setIsActivePaymentSys(false);
        }
    }, [selectedPayOption]);

    const sum = useMemo(() => {
        return (
            (cartData?.account_total_prices?.find((acc) => acc?.id === selectedPayOption?.currency_account_id)?.total_price ||
                cartData?.account_total_price) + (delivery?.user_price?.main_price ? +delivery?.user_price?.main_price : 0)
        );
    }, [cartData, selectedPayOption, delivery]);

    useEffect(() => {
        if (!selectedPaymentSystems?.length) {
            setSelectedPayOption(null);
        }
    }, [selectedPaymentSystems]);

    return (
        <div>
            {/* {paymentsErrors?.length ? (
                <div style={{ marginBottom: 25 }}>
                    {paymentsErrors?.length
                        ? paymentsErrors.map((item, index) => {
                              return (
                                  <FieldError compStyle={css?.error} key={`paymentError${index}`}>
                                      {item}
                                  </FieldError>
                              );
                          })
                        : null}
                </div>
            ) : null} */}
            <FormSelect
                value={selectedPayOption}
                title={{
                    body: (
                        <T
                            textName='CartPaymentSelectDefaultPaymentTypeLabel'
                            defaultStr='Выберите способ оплаты'
                            page='/store'
                        />
                    )
                }}
                errors={paymentsErrors}
                info={
                    isActiveInternalAcc ? (
                        <p>
                            <T textName='CartPaymentSelectDefaultPaymentTypeLabel1' defaultStr='Сумма списания' page='/store' />{' '}
                            <Display
                                type='value'
                                data={{
                                    value: sum,
                                    currency: { symbol: 'PV', displayed_decimals_number: 2 },
                                    formatByDecimal: true
                                }}
                            />
                        </p>
                    ) : null
                }
                options={payment_methods}
                setFormData={onSelectPaymentMethod}
                required={true}
            />

            {/* <FormCheckboxSwitcher
                compStyle={{ wrapper: css.dn2, label: css.checkboxLabelBlock, title: css.checkerTitleText }}
                value={isComboPayment}
                handlers={{
                    onChange: (newValue) => {
                        setIsComboPayment(newValue);
                    }
                }}
                title={{
                    body: t('CartPaymentCheckerLabel', 'Комбинированная оплата', '/store', translation)
                }}
                setFormData={() => null}
            /> */}
            {/* <div className={css.paymentBlockTitle}>
                {isComboPayment ? (
                    <T
                        textName='CartPaymentSelectComboPaymentTypeLabel'
                        defaultStr='Выберите 2 любых способа оплаты'
                        page='/store'
                    />
                ) : (
                    <T textName='CartPaymentSelectDefaultPaymentTypeLabel' defaultStr='Выберите способ оплаты' page='/store' />
                )}
            </div> */}
            {/* <div className={css.paymentSystemsContainer}>
                {storeData?.financeData?.length
                    ? storeData?.financeData.map((paymentSystem) => {
                          const isActive = selectedPaymentSystems.some((item) => item.id === paymentSystem.id);
                          const isDisabled =
                              Boolean(!paymentSystem?.balance) ||
                              (selectedPaymentSystems?.length == 2 &&
                                  !selectedPaymentSystems.some((item) => item.id === paymentSystem.id));
                          return (
                              <InternalAccBlock
                                  key={paymentSystem.id + 'paymentAccountChoice'}
                                  {...{
                                      isActive,
                                      isDisabled,
                                      isComboPayment,
                                      paymentSystem,
                                      handleClickOnPaymentSys,
                                      handleClickCheckboxInternalAcc,
                                      handleSetPartOfSumValue,
                                      selectedPaymentSystems,
                                      localization,
                                      cartData,
                                      convertLoading,
                                      convertedData
                                  }}
                              />
                          );
                      })
                    : null}
                {!formattedPaymentData?.length ? null : (
                    <div className={css.paymentSysBlock}>
                        <div ref={paymentSysContainerRef} className={css.inlineWrapSelectPaymentSys}>
                            <FormSelect
                                compStyle={{
                                    wrapper: {
                                        className: css.selectPaymentSystem
                                    },
                                    placeholder: {
                                        lineHeight: 1.3
                                    },
                                    wrapperOption: css.wrapperOptionSelectPaymentSys,
                                    formSelectOption: css.optionSelectPaymentSys,
                                    formSelectMenuList: css.menuListPaymentSys,
                                    formSelectMenu: { className: css.menuWrapperPaymentSys },
                                    inputFocus: css.focusedSelectPaymentSystem,
                                    formControlInner: css.paymentInputSelectControlInner,
                                    formControlContent: css.paymentInputSelectControlContent,
                                    input: classNames(css.paymentInputSelect, isActivePaymentSys ? css.selectedPaymentSystem : '')
                                    // title: css.formTitle
                                }}
                                autoFocus={false}
                                searchInputProps={{
                                    autocomplete: 'off'
                                }}
                                insertComponentBefore={
                                    <>
                                        <SelectBlock
                                            isDisabled={
                                                selectedPaymentSystems?.length === 2 &&
                                                !selectedPaymentSystems.some((item) => item.keyType === PAYMENT_SYSTEM_TYPE)
                                            }
                                            isActive={isActivePaymentSys}
                                            handleClickCheckbox={handleClickCheckboxPaymentSys}
                                            isComboPayment={isComboPayment}
                                        />
                                        {selectedPaymentSys ? (
                                            <>
                                                {
                                                    linksInstructionsPayment({
                                                        customStyle: {
                                                            width: 24,
                                                            height: 24,
                                                            marginRight: 12
                                                        }
                                                    })[`${selectedPaymentSys.name}`]?.logoPaymentSystem ||
                                                        linksInstructionsPayment({
                                                            customStyle: {
                                                                width: 24,
                                                                height: 24,
                                                                marginRight: 12
                                                            }
                                                        })[`${selectedPaymentSys.alias}`]?.logoPaymentSystem ||
                                                        svgSprite('menu-wallets', {
                                                            width: 24,
                                                            height: 24,
                                                            fill: 'rgba(67, 95, 197, 1)',
                                                            style: {
                                                                marginRight: 12
                                                            }
                                                        })
                                                    // : null
                                                }
                                            </>
                                        ) : null}
                                    </>
                                }
                                attribute={PAYMENT_SYSTEM_TYPE}
                                type='dropdown'
                                disabled={
                                    selectedPaymentSystems?.length == 2 &&
                                    !selectedPaymentSystems.some((item) => item.keyType === PAYMENT_SYSTEM_TYPE)
                                }
                                insertComponentInOptionBefore={(data) => {
                                    const { value, options } = data;
                                    const item = options.find((el) => value.value === el.value);
                                    return (
                                        <>
                                            {linksInstructionsPayment({
                                                customStyle: {
                                                    width: 24,
                                                    height: 24,
                                                    marginRight: 12
                                                }
                                            })[`${item.name}`]?.logoPaymentSystem ||
                                                linksInstructionsPayment({
                                                    customStyle: {
                                                        width: 24,
                                                        height: 24,
                                                        marginRight: 12
                                                    }
                                                })[`${item.alias}`]?.logoPaymentSystem ||
                                                svgSprite('menu-wallets', {
                                                    width: 24,
                                                    height: 24,
                                                    fill: 'rgba(67, 95, 197, 1)',
                                                    style: {
                                                        marginRight: 12
                                                    }
                                                })}
                                        </>
                                    );
                                }}
                                value={selectedPaymentSys}
                                hint={null}
                                options={formattedPaymentData || []}
                                placeholder={t(
                                    'paymentsystemselectstoreplaceholder-store',
                                    'Выберите платежную систему',
                                    '/store',
                                    translation
                                )}
                                // required={true}
                                customOption={true}
                                setFormData={handleSetSelectedPaymentSys}
                            />
                            {isActivePaymentSys && isComboPayment ? (
                                <FormInput
                                    validationFormatter={(input) => validationPartSumNumbers(input, cartData?.total_price)}
                                    compStyle={{
                                        wrapper: { className: css.sumValueInputWrapper },
                                        // error: { wrapper: { className: uikit.none } }
                                        formControlContentAddon: css.sumValuePaymentSysInputControlContentAddon,
                                        inputFocus: css.sumValuePaymentSysInputFormControlFocus,
                                        input: css.sumValuePaymentSysInputFormControl,
                                        addon: css.currencyPaymentSysAddon
                                    }}
                                    setFormData={(attribute, val) => handleSetPartOfSumValue(PAYMENT_SYSTEM_TYPE, val)}
                                    value={selectedPaymentSystems?.find((item) => item.keyType === PAYMENT_SYSTEM_TYPE)?.sumValue}
                                    addon={
                                        // <div className={css.currencySumComboPaymentSys}>
                                        cartData?.currency?.code
                                        // </div>
                                    }
                                    placeholder={'0.00'}
                                />
                            ) : null}
                        </div>
                        <div className={css.selectCurrency_convertBlock_block}>
                            {isActivePaymentSys ? (
                                <div className={css.currencyPaymentSelectBlock}>
                                    <div className={classNames(css.paymentBlockTitle, css.currencySelectLabel)}>
                                        <T
                                            textName='CurrencyPaymentSelectLabel'
                                            defaultStr='Валюта платежной системы'
                                            page='/store'
                                        />
                                    </div>
                                    <div className={css.currencyPaymentSelectWrap}>
                                        <FormSelect
                                            compStyle={{
                                                input: css.sumValueInputFormControl,
                                                wrapper: css.sumValuePaymentSysCurrencyInputFullWrapper
                                            }}
                                            attribute='payment_currency_id'
                                            type='dropdown'
                                            placeholder={localization?.currency}
                                            disabled={currentCurrenciesList.length === 1}
                                            value={currencyValue}
                                            hint={null}
                                            options={currentCurrenciesList}
                                            required={true}
                                            noTranslate={true}
                                            setFormData={setCurrency}
                                            errors={formDataError['payment_currency_id']}
                                        />
                                    </div>
                                </div>
                            ) : null}
                            {isComboPayment &&
                            selectedPaymentSystems?.find((item) => item?.id === selectedPaymentSys?.id)?.sumValue &&
                            localization?.currency !== cartData?.main_currency?.code ? (
                                <ConvertBlock
                                    convertLoading={convertLoading?.some((item) => item === selectedPaymentSys?.id)}
                                    currency={cartData?.main_currency}
                                    value={convertedData?.find((item) => item?.id === selectedPaymentSys?.id)?.amount || '——'}
                                />
                            ) : null}
                        </div>
                    </div>
                )}
            </div> */}
            {isActivePaymentSys ? (
                <div className={css.currencyPaymentSelectBlock}>
                    {/* <div className={classNames(css.paymentBlockTitle, css.currencySelectLabel)}>
                        <T textName='CurrencyPaymentSelectLabel' defaultStr='Валюта платежной системы' page='/store' />
                    </div> */}
                    <div className={css.currencyPaymentSelectWrap}>
                        <FormSelect
                            compStyle={{
                                input: css.sumValueInputFormControl,
                                wrapper: css.sumValuePaymentSysCurrencyInputFullWrapper
                            }}
                            attribute='payment_currency_id'
                            type='dropdown'
                            placeholder={localization?.currency}
                            disabled={currentCurrenciesList.length === 1}
                            value={currencyValue}
                            options={currentCurrenciesList}
                            required={true}
                            noTranslate={true}
                            setFormData={setCurrency}
                            errors={formDataError['payment_currency_id'] || formDataError['payment_system_currency_id']}
                            title={{
                                body: (
                                    <T
                                        textName='CurrencyPaymentSelectLabel'
                                        defaultStr='Валюта платежной системы'
                                        page='/store'
                                    />
                                )
                            }}
                        />
                    </div>
                </div>
            ) : null}
            {isActiveInternalAcc && 0 ? (
                <FinPasswordBlock
                    finPassError={finPassError}
                    // formDataError={formDataError}
                    setFormData={setFormDataMain}
                    classes={{
                        finPasswordBlockTitle: {
                            rewrite: true,
                            class: css.finPasswordBlockTitle
                        },
                        finPasswordBlockContentContainer: {
                            rewrite: true,
                            class: css.finPasswordBlockContentContainer
                        },
                        finPasswordBlock: {
                            rewrite: true,
                            class: css.finPasswordBlock
                        },
                        finPasswordPaymentCartInputWrapper: {
                            // rewrite: true,
                            class: css.finPasswordPaymentCartInputWrapper
                        },
                        finPassTooltipBlock: {
                            // rewrite: true,
                            class: css.finPassTooltipBlock
                        },
                        finPassTooltipBlockBtnForHide: {
                            class: css.finPassTooltipBlockBtnForHide
                        }
                    }}
                />
            ) : null}

            {/* <div style={{ zIndex: 0 }} className={css.commentBlockWrapper}>
                <FormTextArea
                    compStyle={{
                        wrapper: { style: { zIndex: 0 } }
                    }}
                    attribute='comment'
                    disabled={false}
                    title={{ body: t('storeComment', 'Комментарий к заказу', '/store', translation) }}
                    setFormData={setFormDataMain}
                    rows={3}
                />
            </div> */}
            {/* <div>
                <FormCheckbox
                    attribute='do_not_call_back'
                    disabled={false}
                    title={{
                        body: (
                            <div>
                                <T
                                    textName='storeNoCall'
                                    defaultStr='Не перезванивать мне для подтверждения заказа'
                                    page='/store'
                                />
                            </div>
                        )
                    }}
                    handlers={{}}
                    value={'0'}
                    setFormData={setFormDataMain}
                />
            </div> */}
            {/* <div>
                <FormCheckbox
                    attribute='police_agree'
                    disabled={false}
                    title={{
                        body: getTitle(translation)
                    }}
                    errors={formDataError['police_agree']}
                    handlers={{}}
                    value={'0'}
                    setFormData={setFormDataMain}
                />
            </div> */}
        </div>
    );
};
export default CartFooterForm;
